"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Case = exports.CaseItem = exports.If = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var comparison_1 = require("../util/comparison");
// TODO: Spec lists "Conditional", but it's "If" in the XSD
var If = /** @class */ (function (_super) {
    __extends(If, _super);
    function If(json) {
        var _this = _super.call(this, json) || this;
        _this.condition = (0, builder_1.build)(json.condition);
        _this.th = (0, builder_1.build)(json.then);
        _this.els = (0, builder_1.build)(json.else);
        return _this;
    }
    If.prototype.exec = function (ctx) {
        if (this.condition.execute(ctx)) {
            return this.th.execute(ctx);
        }
        else {
            return this.els.execute(ctx);
        }
    };
    return If;
}(expression_1.Expression));
exports.If = If;
var CaseItem = /** @class */ (function () {
    function CaseItem(json) {
        this.when = (0, builder_1.build)(json.when);
        this.then = (0, builder_1.build)(json.then);
    }
    return CaseItem;
}());
exports.CaseItem = CaseItem;
var Case = /** @class */ (function (_super) {
    __extends(Case, _super);
    function Case(json) {
        var _this = _super.call(this, json) || this;
        _this.comparand = (0, builder_1.build)(json.comparand);
        _this.caseItems = json.caseItem.map(function (ci) { return new CaseItem(ci); });
        _this.els = (0, builder_1.build)(json.else);
        return _this;
    }
    Case.prototype.exec = function (ctx) {
        if (this.comparand) {
            return this.exec_selected(ctx);
        }
        else {
            return this.exec_standard(ctx);
        }
    };
    Case.prototype.exec_selected = function (ctx) {
        var val = this.comparand.execute(ctx);
        for (var _i = 0, _a = this.caseItems; _i < _a.length; _i++) {
            var ci = _a[_i];
            if ((0, comparison_1.equals)(ci.when.execute(ctx), val)) {
                return ci.then.execute(ctx);
            }
        }
        return this.els.execute(ctx);
    };
    Case.prototype.exec_standard = function (ctx) {
        for (var _i = 0, _a = this.caseItems; _i < _a.length; _i++) {
            var ci = _a[_i];
            if (ci.when.execute(ctx)) {
                return ci.then.execute(ctx);
            }
        }
        return this.els.execute(ctx);
    };
    return Case;
}(expression_1.Expression));
exports.Case = Case;
//# sourceMappingURL=conditional.js.map